import React from 'react';
import Animated from './AnimatedComponent';

const SectionTitle = ({ label, className }: { label: string; className?: string }) => {
  return (
    <Animated.Component className={`text-3xl font-bold mt-2 pb-2 text-black dark:text-orange-500 ${className}`}>
      {label}
    </Animated.Component>
  );
};

export default SectionTitle;
